export const moduleRoutes = {
  root: 'home',
  childForms: {
    homePage: {
      data: { title: 'Inicio' },
      requireAuth: false,
      functions: [],
      route: 'homePage',
    },
    genericCards: {
      // /:form...
      data: { title: 'Inicio' },
      requireAuth: false,
      functions: [],
      route: 'formcards',
    },
    genericAllTabbed: {
      // /:form...
      data: { title: 'Inicio' },
      requireAuth: false,
      functions: [],
      route: 'formalltabbed',
    },
    genericTabbed: {
      // /:form...
      data: { title: 'Inicio' },
      requireAuth: false,
      functions: [],
      route: 'formtabbed',
    },
    vipWelcomePage: {
      // /:form...
      data: { title: 'Inicio' },
      requireAuth: true,
      functions: [],
      route: 'vip',
    },
    commonWelcomePage: {
      // /:form...
      data: { title: 'Inicio' },
      requireAuth: true,
      functions: [],
      route: 'common',
    },
  },
  layout: 'home',
  loadChildren: () => import('src/app/pages/home/home.module').then(m => m.HomeModule),
};
